import React, { Fragment, useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon, PencilIcon, XMarkIcon as CancelIcon } from '@heroicons/react/24/outline';
import { KitDocumentType, NoteData, SbCurrentUser, SbRecipientModel, SubmissionBoardModel, SubmissionKitTagsModel } from './SbModel';
import SbAddNote from './SbAddNote';
import submissionBoardService from '../../services/SubmissionBoardService';
import Button from './Button';
import { CheckCircleIcon, CheckIcon, CircleCheckIcon, CircleIcon, PlusIcon, XIcon } from 'lucide-react';
import { KitDocumentModel, MediaKitModel, SubmissionKitDocumentModel, HmuKitDocumentModel, WardrobeKitDocumentModel, OverviewKitDocumentModel } from '../../submission_kits/components/KitModels';
import CustomTabs from './CustomTabs';
import FilePreviewer from '../../submission_kits/components/FilePreviewer';
import MediaUploadModal from './MediaUploadModal';
import mediaKitService from '../../services/MediaKitService';
import { showToast } from '../../shared/Toast';
import { useIsMobile } from './useIsMobile';

export interface MediaKitModalProps {
  currentUser: SbCurrentUser;
  from?: string;
  mediaKitDocuments: KitDocumentModel[];
  submissionKitDocuments?: SubmissionKitDocumentModel[];
  hmuKitDocuments?: HmuKitDocumentModel[];
  wardrobeKitDocuments?: WardrobeKitDocumentModel[];
  overviewKitDocuments?: OverviewKitDocumentModel[];
  filetype?: number;
  dialogCloseHandler: () => void;
  selectedMediaKitHandler: (kitDocumentModel: KitDocumentModel) => Promise<boolean>;
}


export default function MediaKitModal({
  currentUser,
  from,
  mediaKitDocuments,
  submissionKitDocuments,
  hmuKitDocuments,
  wardrobeKitDocuments,
  overviewKitDocuments,
  filetype,
  dialogCloseHandler,
  selectedMediaKitHandler,
}: MediaKitModalProps) {
  const [mediaKit, setMediaKit] = useState<MediaKitModel>();
  const [mediaKitDocumentsSelected, setMediaKitDocumentsSelected] = useState<KitDocumentModel[]>(
    []
  );
  const [submissionKitDocumentsSelected, setSubmissionKitDocumentsSelected] = useState<
    SubmissionKitDocumentModel[]
  >([]);
  const [hmuKitDocumentsSelected, setHmuKitDocumentsSelected] = useState<
    HmuKitDocumentModel[]
  >([]);
  const [wardrobeKitDocumentsSelected, setWardrobeKitDocumentsSelected] = useState<
    WardrobeKitDocumentModel[]
  >([]);
  const [overviewKitDocumentsSelected, setOverviewKitDocumentsSelected] = useState<
    OverviewKitDocumentModel[]
  >([]);
  const [tabSelected, setTabSelected] = useState<number>(1);
  const [tabs, setTabs] = useState([]);
  const [kitSelected, setKitSelected] = useState<KitDocumentModel | null>(null);
  const [showReplaceModal, setshowReplaceModal] = useState<number>(0);

  const [showDialog, setShowDialog] = useState(true);
  const isMobile = useIsMobile();

  // useEffect(() => {
  //   let kitDocumentModel: KitDocumentModel = {
  //     id: -1,
  //     featured: 0,
  //     created_at: '',
  //     uuid: '',
  //     file_url: '',
  //     file_name: 'Upload New Photo...',
  //     file_content_type: 'image/jpeg',
  //     // file_name: filetype == KitDocumentType.Image ? 'Upload New Photo...' : 'Upload New Video...',
  //     // file_content_type: filetype == KitDocumentType.Video ? 'image/jpeg' : 'video/mp4',
  //     work_kit_id: null,
  //     wardrobe_kit_id: null,
  //     hair_make_up_kit_id: null,
  //   };
  //   let kitDocumentModel2: KitDocumentModel = {
  //     id: -1,
  //     featured: 0,
  //     created_at: '',
  //     uuid: '',
  //     file_url: '',
  //     file_name: 'Upload New Video...',
  //     file_content_type: 'video/mp4',
  //     // file_name: filetype == KitDocumentType.Image ? 'Upload New Photo...' : 'Upload New Video...',
  //     // file_content_type: filetype == KitDocumentType.Video ? 'image/jpeg' : 'video/mp4',
  //     work_kit_id: null,
  //     wardrobe_kit_id: null,
  //     hair_make_up_kit_id: null,
  //   };
  //   setMediaKitDocumentsSelected([...[kitDocumentModel, kitDocumentModel2], ...mediaKitDocuments]);
  //   console.log('MediaKitModal: setMediaKitDocumentsSelected', mediaKitDocuments);
  // }, [mediaKitDocuments]);

  // useEffect(() => {
  //   console.log('MediaKitModal: mediaKitDocumentsSelected', mediaKitDocumentsSelected);
  // }, [mediaKitDocumentsSelected]);

  useEffect(() => {
    setSubmissionKitDocumentsSelected(submissionKitDocuments || []);
    console.log('MediaKitModal: setSubmissionKitDocumentsSelected', submissionKitDocuments);
  }, [submissionKitDocuments]);

  useEffect(() => {
    setHmuKitDocumentsSelected(hmuKitDocuments || []);
    console.log('MediaKitModal: setHmuKitDocumentsSelected', hmuKitDocuments);
  }, [hmuKitDocuments]);

  useEffect(() => {
    setWardrobeKitDocumentsSelected(wardrobeKitDocuments || []);
    console.log('MediaKitModal: setWardrobeKitDocumentsSelected', wardrobeKitDocuments);
  }, [wardrobeKitDocuments]);

  useEffect(() => {
    setOverviewKitDocumentsSelected(overviewKitDocuments || []);
    console.log('MediaKitModal: setOverviewKitDocumentsSelected', overviewKitDocuments);
  }, [overviewKitDocuments]);

  useEffect(() => {
    let _tabs = [];
    if (filetype) {
      if (filetype == KitDocumentType.Image) {
        _tabs.push({ id: KitDocumentType.Image, name: 'Your Photos', show: true });
      }
      if (filetype == KitDocumentType.Video) {
        _tabs.push({ id: KitDocumentType.Video, name: 'Your Videos', show: true });
      }
      setTabs(_tabs);
    }
    fetchMediaKits(1);
  }, [filetype]);
  const isMobileScreen = useMedia('(max-width: 1024px)', false);

  const onCloseDialog = () => {
    dialogCloseHandler();
    setShowDialog(false);
  };

  const isInSubmissionKit = (kitDocumentId: number): boolean => {
    return submissionKitDocumentsSelected.some(
      (submissionKitDoc) => submissionKitDoc.kit_document_id === kitDocumentId
    );
  };

  const isInHmuKit = (kitDocumentId: number): boolean => {
    return hmuKitDocumentsSelected.some(
      (hmuKitDoc) => hmuKitDoc.kit_document_id === kitDocumentId
    );
  };

  const isInWardrobeKit = (kitDocumentId: number): boolean => {
    return wardrobeKitDocumentsSelected.some(
      (wardrobeKitDoc) => wardrobeKitDoc.kit_document_id === kitDocumentId
    );
  };
  const isInOverviewKit = (kitDocumentId: number): boolean => {
    return overviewKitDocumentsSelected.some(
      (kitDoc) => kitDoc.kit_document_id === kitDocumentId
    );
  };


  const isKitDocumentAdded = (kitDocumentId: number): boolean => {
    if (from === 'hmu_kit') {
      return isInHmuKit(kitDocumentId);
    } else if (from === 'wardrobe_kit') {
      return isInWardrobeKit(kitDocumentId);
    } else if (from === 'overview_kit') {
      return isInOverviewKit(kitDocumentId);
    } else {
      return isInSubmissionKit(kitDocumentId);
    }
  };
  const fetchMediaKits = async (pageParam: number) => {
    try {
      console.log('sk: fetchMediaKits In');
      if (mediaKitDocuments.length <= 0) {
        pageParam = 1;
      }
      let filter = '';
      const responseData = await mediaKitService.fetchMediaKits(filter, 'new', pageParam, 999999);
      if (responseData) {
        if (responseData.media_kit) {
          setMediaKit(responseData.media_kit);
        }
        let kitDocumentModelImage: KitDocumentModel = {
          id: -1,
          featured: 0,
          created_at: '',
          uuid: '',
          file_url: '',
          file_name: 'Upload New Photo...',
          file_content_type: 'image/jpeg',
          // file_name: filetype == KitDocumentType.Image ? 'Upload New Photo...' : 'Upload New Video...',
          // file_content_type: filetype == KitDocumentType.Video ? 'image/jpeg' : 'video/mp4',
          work_kit_id: null,
          wardrobe_kit_id: null,
          hair_make_up_kit_id: null,
        };
        let kitDocumentModelVideo: KitDocumentModel = {
          id: -1,
          featured: 0,
          created_at: '',
          uuid: '',
          file_url: '',
          file_name: 'Upload New Video...',
          file_content_type: 'video/mp4',
          // file_name: filetype == KitDocumentType.Image ? 'Upload New Photo...' : 'Upload New Video...',
          // file_content_type: filetype == KitDocumentType.Video ? 'image/jpeg' : 'video/mp4',
          work_kit_id: null,
          wardrobe_kit_id: null,
          hair_make_up_kit_id: null,
        };
        if (responseData.kit_documents.length > 0) {
          setMediaKitDocumentsSelected([
            ...[kitDocumentModelImage, kitDocumentModelVideo],
            ...responseData.kit_documents,
          ]);
        } else {
          setMediaKitDocumentsSelected([kitDocumentModelImage, kitDocumentModelVideo]);
        }
        return;
      }
    } catch (error) {
      showToast('Error while fetching media kits.', 'danger');
    } finally {
      console.log('sk: fetchMediaKits Out');
      console.log('sk: isLoading false');
      // setIsLoading(false);
    }
  };
  return (
    <Transition.Root show={showDialog} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onCloseDialog}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-customGray" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center m-6 text-left">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="relative flex flex-col bg-white rounded-md shadow-xl overflow-hidden"
                style={{
                  width: isMobile ? '100%' : '80vw',
                  maxWidth: '31.25rem',
                  maxHeight: '90vh',
                }}
              >
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-5 flex-none">
                  <h2 className="text-lg font-medium text-black">Media Kit Files</h2>
                  <button
                    className="flex items-center justify-center text-gray-700 hover:text-gray-600 transition-colors h-6 w-6"
                    onClick={onCloseDialog}
                  >
                    <XIcon className="w-6 h-6" />
                  </button>
                </div>

                <div className="text-13 text-gray-700 flex-none px-4 sm:px-10">
                  Select the Media file you want to add:
                </div>

                <div className="gap-4 flex justify-between items-center flex-none px-4 sm:px-10">
                  <div className="text-sm font-medium primary-color w-full flex flex-row">
                    <CustomTabs tabs={tabs} tabSelected={tabSelected} tabSelectHandler={(id: number) => setTabSelected(id)} />
                  </div>
                </div>
                {/* Scrollable Content */}
                <div className="flex flex-col flex-grow overflow-y-auto px-4 sm:px-10 gap-5">
                  <div className="flex flex-col gap-2 py-2">
                    {/* {[...Array(40)].map((_, i) => (
                      <div key={i}>Vinod</div>
                    ))} */}
                    {mediaKitDocumentsSelected.map((kit_document, index) => {
                      let showKit = false;
                      if (
                        kit_document.file_content_type.startsWith('image') &&
                        filetype == KitDocumentType.Image
                      ) {
                        showKit = true;
                      } else if (
                        kit_document.file_content_type.startsWith('video') &&
                        filetype == KitDocumentType.Video
                      ) {
                        showKit = true;
                      }
                      if (!showKit) {
                        return <></>;
                      }

                      const isAdded = isKitDocumentAdded(kit_document.id);
                      return (
                        <div
                          key={index}
                          className="flex flex-row justify-start items-center p-2 gap-2-1 rounded-lg box-shadow-102"
                        >
                          <div
                            className={`rounded-lg overflow-hidden w-14-1 ${isAdded ? 'blur-sm opacity-60' : ''
                              } ${filetype == KitDocumentType.Video ? ' w-24-1 ' : ''}
                            `}
                          >
                            {kit_document.file_url !== '' ? (
                              <FilePreviewer
                                showControl={false}
                                // file_url={kit_document.cropped_file_url || kit_document.file_url}
                                file_url={
                                    kit_document.file_content_type.startsWith('image') ? 
                                    (kit_document.cropped_file_url ??
                                    kit_document.file_url) : 
                                    kit_document.file_url
                                    
                                  }
                                  poster_url={
                                    kit_document.file_content_type.startsWith('image') ? '' : 
                                    kit_document.cropped_file_url
                                  }

                                file_name={kit_document.file_name}
                                file_content_type={kit_document.file_content_type}
                              />
                            ) : (
                              <>
                                <div className="flex flex-col bg-blue-201 rounded-lg border-2 border-dashed border-gray-400">
                                  <div
                                    className={
                                      'flex flex-col justify-center items-center rounded-lg ' +
                                      (filetype == KitDocumentType.Video
                                        ? 'h-7-1 w-24-1'
                                        : 'h-8-1 w-14-1')
                                    }
                                    onClick={() => {
                                      setshowReplaceModal(filetype);
                                    }}
                                  >
                                    <PlusIcon className="w-6 h-6" />
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                          <div className="px-4 py-2-1 flex-1 flex flex-row justify-between items-center gap-2-1 truncate">
                            <div className="text-xs font-medium flex justify-start items-center truncate">
                              {kit_document.file_name}
                            </div>
                            {kit_document.file_url !== '' && (
                              <div className="text-green-600">
                                {isAdded && <CheckIcon className="h-6 w-6" aria-hidden="true" />}
                                {!isAdded && (
                                  <div
                                    className={
                                      kitSelected && kit_document.id == kitSelected.id
                                        ? 'text-blue-600'
                                        : 'text-gray-301'
                                    }
                                    onClick={(e) => {
                                      console.log('radio kit_document', kit_document);
                                      setKitSelected(kit_document);
                                    }}
                                  >
                                    {kitSelected && kit_document.id == kitSelected.id ? (
                                      <CircleCheckIcon className="h-6 w-6" aria-hidden="true" />
                                    ) : (
                                      <CircleIcon className="h-6 w-6" aria-hidden="true" />
                                    )}

                                    {/* <input
                                      type="radio"
                                      id={'select_media_id_' + index}
                                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring focus:ring-blue-500"
                                      checked={kitSelected && kit_document.id == kitSelected.id}
                                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        console.log('radio kit_document', kit_document);
                                        setKitSelected(kit_document);
                                      }}
                                    /> */}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Footer */}
                <div className="gap-4 flex justify-center  items-center px-10 py-10 flex-none">
                  <div className="flex items-center justify-center gap-2 pt-2">
                    <Button id="cancel_mk_modal_button" variant="secondary" onClick={onCloseDialog}>
                      Cancel
                    </Button>
                    <Button
                      id="add_mk_ske_button"
                      variant="primary"
                      onClick={async () => {
                        if (selectedMediaKitHandler) {
                          if (await selectedMediaKitHandler(kitSelected)) {
                            onCloseDialog();
                          }
                        }
                      }}
                      className="whitespace-nowrap gap-x-1 px-2 "
                    >
                      <div className="sm:w-4 w-6 h-6  flex items-center justify-center ">
                        <PlusIcon className="w-4-2 h-4-2" />
                      </div>
                      {from === 'hmu_kit' ? 'Add to Hair & Make-up Kit' : (from === 'wardrobe_kit' ? 'Add to Wardrobe Kit' : ((from === 'overview_kit' ? 'Add to Overview' : 'Add to Submission Kit')))}
                    </Button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
        {showReplaceModal > 0 && (
          <div>
            <MediaUploadModal
              currentUser={currentUser}
              dialogCloseHandler={function (): void {
                setshowReplaceModal(0);
              }}
              fromScreen={'mediakitmodal'}
              filetype={showReplaceModal}
              fetchMediaKitHandler={async function (): Promise<void> {
                await fetchMediaKits(1);
              }}
            />
          </div>
        )}
      </Dialog>
    </Transition.Root>
  );
}